export default theme => ({
  formSection: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(3)
    },
    '& .MuiTypography-h3': {
      fontSize: 18,
      fontWeight: 400,
      '&.MuiTypography-gutterBottom': {
        marginBottom: theme.spacing(2)
      }
    },
    '& .MuiTypography-body1': {
      fontSize: 14,
      '&.MuiTypography-gutterBottom': {
        marginBottom: theme.spacing(1)
      }
    }
  },
  startDateTime: {
    display: 'flex'
  },
  timezone: {
    marginTop: 10,
    marginLeft: theme.spacing(2),
    color: theme.palette.text.secondary
  },
  datePicker: {
    width: 190,
    marginTop: 0,
    marginBottom: 0,
    marginRight: theme.spacing(2),
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: 0
    },
    '& .MuiFormHelperText-root': {
      whiteSpace: 'nowrap'
    }
  },
  timePicker: {
    width: 150,
    marginTop: 0,
    marginBottom: 0,
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: 0
    }
  },
  frequencyContainer: {
    display: 'flex',
    '& > div': {
      marginRight: theme.spacing(2)
    }
  },
  customCron: {
    margin: 0
  },
  conceptsOptions: {},
  synchronizablesContainer: {
    minHeight: 52,
    display: 'flex',
    alignItems: 'center',
    '& .MuiAutocomplete-root': {
      flex: 1,
      '& .MuiFormHelperText-root': {
        marginBottom: -24
      }
    }
  },
  selectAllButton: {
    marginLeft: theme.spacing(1)
  },
  actions: {
    display: 'flex',
    justifyContent: 'right',
    marginBottom: theme.spacing(1),
    '& > *': {
      marginLeft: theme.spacing(2)
    }
  }
});
